module.exports = __webpack_public_path__ + "img/MVP-TAG.47a10389.png";